"use strict";

exports.__esModule = true;
exports.Heading = Heading;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Theme = require("../../Theme");
var _excluded = ["level", "ellipsize", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var H1 = (0, _styledComponents["default"])("h1").withConfig({
  displayName: "Heading__H1",
  componentId: "sc-18d86h-0"
})(["color:", ";overflow:hidden;.", " + &{margin-top:0.5rem;}"], (0, _Theme.val)("HeadingColor"), _core.Classes.BREADCRUMBS);
var H2 = H1.withComponent("h2");
var H3 = H1.withComponent("h3");
var H4 = H1.withComponent("h4");
var H5 = H1.withComponent("h5");
var H6 = H1.withComponent("h6");
var headings = [H1, H2, H3, H4, H5, H6];
var getHeadingComponent = function getHeadingComponent(level) {
  var item = Number(level);
  if (item < 1 || item > headings.length) {
    console.warn("Invalid heading level, expected 1 - 6, got", level);
    item = 1;
  }
  return headings[item - 1];
};

/**
 * Displays a Heading.
 */
function Heading(_ref) {
  var _ref$level = _ref.level,
    level = _ref$level === void 0 ? 1 : _ref$level,
    ellipsize = _ref.ellipsize,
    children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var H = getHeadingComponent(level);
  if (ellipsize) {
    return /*#__PURE__*/_react["default"].createElement(H, extra, /*#__PURE__*/_react["default"].createElement(_core.Text, {
      ellipsize: true
    }, children));
  }
  return /*#__PURE__*/_react["default"].createElement(H, extra, children);
}